"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const art_layout_names_1 = __importDefault(require("./art-layout-names"));
const art_sets_backgrounds_1 = __importDefault(require("./art-sets-backgrounds"));
const tiles_1 = require("../tiles");
const sevenLayouts = [
    {
        id: art_layout_names_1.default.PYRAMID_PORTRAIT,
        displayName: 'Pyramid',
        sets: [
            {
                backgroundImagePath: art_sets_backgrounds_1.default.GREY_COUCH_BLANKET,
                tiles: [
                    {
                        id: 'couch_7_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.3161120840630473,
                            y: 0.4019264448336252,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'couch_7_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.37040280210157617,
                            y: 0.28633975481611207,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'couch_7_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.4080560420315236,
                            y: 0.4019264448336252,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'couch_7_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.46234676007005254,
                            y: 0.28633975481611207,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'couch_7_5',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.5,
                            y: 0.4019264448336252,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'couch_7_6',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.5542907180385289,
                            y: 0.28633975481611207,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'couch_7_7',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.5919439579684763,
                            y: 0.4019264448336252,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.GREY_COUCH_BLANKET,
                tiles: [
                    {
                        id: 'couch_7_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.2530647985989492,
                            y: 0.35376532399299476,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'couch_7_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.3169877408056042,
                            y: 0.19001751313485113,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'couch_7_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.3809106830122592,
                            y: 0.35376532399299476,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'couch_7_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.4448336252189142,
                            y: 0.19001751313485113,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'couch_7_5',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.5087565674255692,
                            y: 0.35376532399299476,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'couch_7_6',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.5726795096322241,
                            y: 0.19001751313485113,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'couch_7_7',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.6366024518388792,
                            y: 0.35376532399299476,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.GREY_COUCH_BLANKET,
                tiles: [
                    {
                        id: 'couch_7_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.12697022767075306,
                            y: 0.3239929947460595,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    },
                    {
                        id: 'couch_7_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.2224168126094571,
                            y: 0.06654991243432574,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    },
                    {
                        id: 'couch_7_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.3178633975481611,
                            y: 0.3239929947460595,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    },
                    {
                        id: 'couch_7_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.4133099824868651,
                            y: 0.06654991243432574,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    },
                    {
                        id: 'couch_7_5',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.5087565674255692,
                            y: 0.3239929947460595,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    },
                    {
                        id: 'couch_7_6',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.6042031523642732,
                            y: 0.06654991243432574,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    },
                    {
                        id: 'couch_7_7',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.6996497373029772,
                            y: 0.3239929947460595,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    }
                ]
            }
        ]
    },
    {
        id: art_layout_names_1.default.SEVEN_TOWER,
        displayName: 'Tower',
        sets: [
            {
                backgroundImagePath: art_sets_backgrounds_1.default.HALL_LAYOUTS,
                tiles: [
                    {
                        id: 'plain_wall_7_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.4168126094570928,
                            y: 0.16987740805604204,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'plain_wall_7_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.4168126094570928,
                            y: 0.28546409807355516,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'plain_wall_7_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.4168126094570928,
                            y: 0.4010507880910683,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'plain_wall_7_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.4168126094570928,
                            y: 0.5166374781085814,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'plain_wall_7_5',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.5087565674255692,
                            y: 0.2276707530647986,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'plain_wall_7_6',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.5087565674255692,
                            y: 0.3432574430823117,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'plain_wall_7_7',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.5087565674255692,
                            y: 0.45884413309982486,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.HALL_LAYOUTS,
                tiles: [
                    {
                        id: 'plain_wall_7_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.3809106830122592,
                            y: 0.1287215411558669,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'plain_wall_7_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.3809106830122592,
                            y: 0.29246935201401053,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'plain_wall_7_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.3809106830122592,
                            y: 0.45621716287215414,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'plain_wall_7_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.3809106830122592,
                            y: 0.6199649737302977,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'plain_wall_7_5',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.5087565674255692,
                            y: 0.21103327495621715,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'plain_wall_7_6',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.5087565674255692,
                            y: 0.37478108581436076,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'plain_wall_7_7',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.5087565674255692,
                            y: 0.5385288966725044,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    }
                ]
            }
        ]
    },
    {
        id: art_layout_names_1.default.SEVEN_ORGANIC,
        displayName: 'Organic',
        sets: [
            {
                backgroundImagePath: art_sets_backgrounds_1.default.COUCH2_LAYOUTS,
                tiles: [
                    {
                        id: 'couch_7_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.28896672504378285,
                            y: 0.19001751313485113,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'couch_7_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.34413309982486867,
                            y: 0.35376532399299476,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'couch_7_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.4168126094570928,
                            y: 0.2381786339754816,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'couch_7_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.47197898423817863,
                            y: 0.35376532399299476,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'couch_7_5',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.5087565674255692,
                            y: 0.19001751313485113,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'couch_7_6',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.563922942206655,
                            y: 0.35376532399299476,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'couch_7_7',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.6366024518388792,
                            y: 0.2381786339754816,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.COUCH2_LAYOUTS,
                tiles: [
                    {
                        id: 'couch_7_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.19001751313485113,
                            y: 0.07180385288966724,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    },
                    {
                        id: 'couch_7_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.276707530647986,
                            y: 0.329246935201401,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    },
                    {
                        id: 'couch_7_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.3809106830122592,
                            y: 0.16549912434325745,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'couch_7_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.46760070052539404,
                            y: 0.329246935201401,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'couch_7_5',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.5087565674255692,
                            y: 0.07180385288966724,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    },
                    {
                        id: 'couch_7_6',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.5954465849387041,
                            y: 0.329246935201401,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    },
                    {
                        id: 'couch_7_7',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.6996497373029772,
                            y: 0.16549912434325745,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    }
                ]
            }
        ]
    },
    {
        id: art_layout_names_1.default.SEVEN_VERTICAL,
        displayName: 'Vertical',
        sets: [
            {
                backgroundImagePath: art_sets_backgrounds_1.default.HALL_LAYOUTS,
                tiles: [
                    {
                        id: 'plain_wall_7_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.5481611208406305,
                            y: 0.36514886164623467,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'plain_wall_7_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.5840630472854641,
                            y: 0.24956217162872155,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'plain_wall_7_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.5840630472854641,
                            y: 0.5288966725043783,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'plain_wall_7_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.6760070052539404,
                            y: 0.1830122591943958,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'plain_wall_7_5',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.6760070052539404,
                            y: 0.29859894921190894,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'plain_wall_7_6',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.6760070052539404,
                            y: 0.4141856392294221,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'plain_wall_7_7',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.6760070052539404,
                            y: 0.5779334500875657,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.HALL_LAYOUTS,
                tiles: [
                    {
                        id: 'plain_wall_7_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.5,
                            y: 0.3283712784588441,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    },
                    {
                        id: 'plain_wall_7_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.5630472854640981,
                            y: 0.1646234676007005,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'plain_wall_7_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.5630472854640981,
                            y: 0.5858143607705779,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'plain_wall_7_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.690893169877408,
                            y: 0.07355516637478109,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'plain_wall_7_5',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.690893169877408,
                            y: 0.2373029772329247,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'plain_wall_7_6',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.690893169877408,
                            y: 0.4010507880910683,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    },
                    {
                        id: 'plain_wall_7_7',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.690893169877408,
                            y: 0.658493870402802,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    }
                ]
            }
        ]
    },
    {
        id: art_layout_names_1.default.SEVEN_STAIRWAY,
        displayName: 'Stairway',
        sets: [
            {
                backgroundImagePath: art_sets_backgrounds_1.default.STAIRWAY_LAYOUTS,
                tiles: [
                    {
                        id: 'stairway_7_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.17162872154115585,
                            y: 0.4124343257443082,
                            width: 0.07880910683012259,
                            height: 0.1042031523642732
                        }
                    },
                    {
                        id: 'stairway_7_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.2679509632224168,
                            y: 0.3607705779334501,
                            width: 0.07880910683012259,
                            height: 0.1042031523642732
                        }
                    },
                    {
                        id: 'stairway_7_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.36427320490367776,
                            y: 0.30910683012259194,
                            width: 0.07880910683012259,
                            height: 0.1042031523642732
                        }
                    },
                    {
                        id: 'stairway_7_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.46059544658493873,
                            y: 0.2565674255691769,
                            width: 0.07880910683012259,
                            height: 0.1042031523642732
                        }
                    },
                    {
                        id: 'stairway_7_5',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.5569176882661997,
                            y: 0.20490367775831875,
                            width: 0.07880910683012259,
                            height: 0.1042031523642732
                        }
                    },
                    {
                        id: 'stairway_7_6',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.6532399299474606,
                            y: 0.15236427320490367,
                            width: 0.07880910683012259,
                            height: 0.1042031523642732
                        }
                    },
                    {
                        id: 'stairway_7_7',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.7495621716287215,
                            y: 0.10070052539404553,
                            width: 0.07880910683012259,
                            height: 0.1042031523642732
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.STAIRWAY_LAYOUTS,
                tiles: [
                    {
                        id: 'stairway_7_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.22854640980735552,
                            y: 0.39404553415061294,
                            width: 0.11646234676007006,
                            height: 0.15499124343257442
                        }
                    },
                    {
                        id: 'stairway_7_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.3274956217162872,
                            y: 0.2723292469352014,
                            width: 0.07880910683012259,
                            height: 0.1042031523642732
                        }
                    },
                    {
                        id: 'stairway_7_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.36252189141856395,
                            y: 0.39404553415061294,
                            width: 0.07880910683012259,
                            height: 0.1042031523642732
                        }
                    },
                    {
                        id: 'stairway_7_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.4238178633975482,
                            y: 0.22154115586690018,
                            width: 0.11646234676007006,
                            height: 0.15499124343257442
                        }
                    },
                    {
                        id: 'stairway_7_5',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.5577933450087565,
                            y: 0.11733800350262696,
                            width: 0.07880910683012259,
                            height: 0.1042031523642732
                        }
                    },
                    {
                        id: 'stairway_7_6',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.5577933450087565,
                            y: 0.23905429071803852,
                            width: 0.07880910683012259,
                            height: 0.1042031523642732
                        }
                    },
                    {
                        id: 'stairway_7_7',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.6541155866900175,
                            y: 0.0840630472854641,
                            width: 0.11646234676007006,
                            height: 0.15499124343257442
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.STAIRWAY_LAYOUTS,
                tiles: [
                    {
                        id: 'stairway_7_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.11558669001751314,
                            y: 0.4886164623467601,
                            width: 0.11646234676007006,
                            height: 0.15499124343257442
                        }
                    },
                    {
                        id: 'stairway_7_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.1532399299474606,
                            y: 0.3660245183887916,
                            width: 0.07880910683012259,
                            height: 0.1042031523642732
                        }
                    },
                    {
                        id: 'stairway_7_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.2504378283712785,
                            y: 0.31436077057793343,
                            width: 0.18213660245183888,
                            height: 0.2521891418563923
                        }
                    },
                    {
                        id: 'stairway_7_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.3415061295971979,
                            y: 0.14185639229422067,
                            width: 0.11646234676007006,
                            height: 0.15499124343257442
                        }
                    },
                    {
                        id: 'stairway_7_5',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.45096322241681264,
                            y: 0.31523642732049034,
                            width: 0.11646234676007006,
                            height: 0.15499124343257442
                        }
                    },
                    {
                        id: 'stairway_7_6',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.4763572679509632,
                            y: 0.0446584938704028,
                            width: 0.18213660245183888,
                            height: 0.2521891418563923
                        }
                    },
                    {
                        id: 'stairway_7_7',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.6768826619964974,
                            y: 0.09281961471103327,
                            width: 0.11646234676007006,
                            height: 0.15499124343257442
                        }
                    }
                ]
            }
        ]
    },
    {
        id: art_layout_names_1.default.SEVEN_GRID,
        displayName: 'Grid',
        sets: [
            {
                backgroundImagePath: art_sets_backgrounds_1.default.COUCH2_LAYOUTS,
                tiles: [
                    {
                        id: 'couch_7_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.3161120840630473,
                            y: 0.4019264448336252,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'couch_7_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.37040280210157617,
                            y: 0.28633975481611207,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'couch_7_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.4080560420315236,
                            y: 0.4019264448336252,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'couch_7_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.46234676007005254,
                            y: 0.28633975481611207,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'couch_7_5',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.5,
                            y: 0.4019264448336252,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'couch_7_6',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.5542907180385289,
                            y: 0.28633975481611207,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'couch_7_7',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.5919439579684763,
                            y: 0.4019264448336252,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.COUCH2_LAYOUTS,
                tiles: [
                    {
                        id: 'couch_7_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.2530647985989492,
                            y: 0.35376532399299476,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'couch_7_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.3169877408056042,
                            y: 0.19001751313485113,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'couch_7_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.3809106830122592,
                            y: 0.35376532399299476,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'couch_7_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.4448336252189142,
                            y: 0.19001751313485113,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'couch_7_5',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.5087565674255692,
                            y: 0.35376532399299476,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'couch_7_6',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.5726795096322241,
                            y: 0.19001751313485113,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'couch_7_7',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.6366024518388792,
                            y: 0.35376532399299476,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.COUCH2_LAYOUTS,
                tiles: [
                    {
                        id: 'couch_7_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.12697022767075306,
                            y: 0.3239929947460595,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    },
                    {
                        id: 'couch_7_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.2224168126094571,
                            y: 0.06654991243432574,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    },
                    {
                        id: 'couch_7_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.3178633975481611,
                            y: 0.3239929947460595,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    },
                    {
                        id: 'couch_7_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.4133099824868651,
                            y: 0.06654991243432574,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    },
                    {
                        id: 'couch_7_5',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.5087565674255692,
                            y: 0.3239929947460595,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    },
                    {
                        id: 'couch_7_6',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.6042031523642732,
                            y: 0.06654991243432574,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    },
                    {
                        id: 'couch_7_7',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.6996497373029772,
                            y: 0.3239929947460595,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    }
                ]
            }
        ]
    },
    {
        id: art_layout_names_1.default.SEVEN_BLOCKS,
        displayName: 'Blocks',
        sets: [
            {
                backgroundImagePath: art_sets_backgrounds_1.default.HALL_LAYOUTS,
                tiles: [
                    {
                        id: 'plain_wall_7_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.45971978984238177,
                            y: 0.287215411558669,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'plain_wall_7_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.5061295971978984,
                            y: 0.17162872154115585,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'plain_wall_7_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.5061295971978984,
                            y: 0.4028021015761821,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'plain_wall_7_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.5516637478108581,
                            y: 0.287215411558669,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'plain_wall_7_5',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.5980735551663747,
                            y: 0.17162872154115585,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'plain_wall_7_6',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.5980735551663747,
                            y: 0.4028021015761821,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'plain_wall_7_7',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.6436077057793345,
                            y: 0.287215411558669,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.HALL_LAYOUTS,
                tiles: [
                    {
                        id: 'plain_wall_7_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.37215411558669004,
                            y: 0.30385288966725044,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'plain_wall_7_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.436077057793345,
                            y: 0.14010507880910683,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'plain_wall_7_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.436077057793345,
                            y: 0.46760070052539404,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'plain_wall_7_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.5,
                            y: 0.30385288966725044,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'plain_wall_7_5',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.563922942206655,
                            y: 0.14010507880910683,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'plain_wall_7_6',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.563922942206655,
                            y: 0.46760070052539404,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'plain_wall_7_7',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.62784588441331,
                            y: 0.30385288966725044,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.HALL_LAYOUTS,
                tiles: [
                    {
                        id: 'plain_wall_7_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.30910683012259194,
                            y: 0.31523642732049034,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    },
                    {
                        id: 'plain_wall_7_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.404553415061296,
                            y: 0.05779334500875657,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    },
                    {
                        id: 'plain_wall_7_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.404553415061296,
                            y: 0.5726795096322241,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    },
                    {
                        id: 'plain_wall_7_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.5,
                            y: 0.31523642732049034,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    },
                    {
                        id: 'plain_wall_7_5',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.5954465849387041,
                            y: 0.05779334500875657,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    },
                    {
                        id: 'plain_wall_7_6',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.5954465849387041,
                            y: 0.5726795096322241,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    },
                    {
                        id: 'plain_wall_7_7',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.690893169877408,
                            y: 0.31523642732049034,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    }
                ]
            }
        ]
    },
    {
        id: art_layout_names_1.default.SEVEN_MOLECULAR,
        displayName: 'Molecular',
        sets: [
            {
                backgroundImagePath: art_sets_backgrounds_1.default.COUCH2_LAYOUTS,
                tiles: [
                    {
                        id: 'couch_7_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.22504378283712784,
                            y: 0.28108581436077057,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'couch_7_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.3169877408056042,
                            y: 0.2574430823117338,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'couch_7_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.35288966725043786,
                            y: 0.4211908931698774,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'couch_7_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.4448336252189142,
                            y: 0.30998248686514884,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'couch_7_5',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.5726795096322241,
                            y: 0.24605954465849386,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'couch_7_6',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.5726795096322241,
                            y: 0.361646234676007,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'couch_7_7',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.7005253940455342,
                            y: 0.38528896672504376,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.COUCH2_LAYOUTS,
                tiles: [
                    {
                        id: 'couch_7_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.09457092819614711,
                            y: 0.18739054290718038,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'couch_7_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.2224168126094571,
                            y: 0.14098073555166374,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    },
                    {
                        id: 'couch_7_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.28546409807355516,
                            y: 0.39842381786339753,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'couch_7_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.4133099824868651,
                            y: 0.20052539404553416,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    },
                    {
                        id: 'couch_7_5',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.6042031523642732,
                            y: 0.10507880910683012,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'couch_7_6',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.6042031523642732,
                            y: 0.2600700525394046,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    },
                    {
                        id: 'couch_7_7',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.7950963222416813,
                            y: 0.3073555166374781,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    }
                ]
            }
        ]
    },
    {
        id: art_layout_names_1.default.SEVEN_CLOUD,
        displayName: 'Cloud',
        sets: [
            {
                backgroundImagePath: art_sets_backgrounds_1.default.DOOR_LAYOUTS,
                tiles: [
                    {
                        id: 'door_7_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.4124343257443082,
                            y: 0.2373029772329247,
                            width: 0.13747810858143608,
                            height: 0.18213660245183888
                        }
                    },
                    {
                        id: 'door_7_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.45709281961471104,
                            y: 0.4413309982486865,
                            width: 0.09281961471103327,
                            height: 0.12259194395796848
                        }
                    },
                    {
                        id: 'door_7_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.5718038528896673,
                            y: 0.14098073555166374,
                            width: 0.2224168126094571,
                            height: 0.30035026269702275
                        }
                    },
                    {
                        id: 'door_7_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.5718038528896673,
                            y: 0.46322241681260945,
                            width: 0.13747810858143608,
                            height: 0.18213660245183888
                        }
                    },
                    {
                        id: 'door_7_5',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.7311733800350263,
                            y: 0.46409807355516636,
                            width: 0.09281961471103327,
                            height: 0.12259194395796848
                        }
                    },
                    {
                        id: 'door_7_6',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.8161120840630472,
                            y: 0.17425569176882663,
                            width: 0.09281961471103327,
                            height: 0.12259194395796848
                        }
                    },
                    {
                        id: 'door_7_7',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.8161120840630472,
                            y: 0.318739054290718,
                            width: 0.09281961471103327,
                            height: 0.12259194395796848
                        }
                    }
                ]
            }
        ]
    },
    {
        id: art_layout_names_1.default.SEVEN_SQUARE,
        displayName: 'Seven',
        sets: [
            {
                backgroundImagePath: art_sets_backgrounds_1.default.GREY_COUCH_BLANKET,
                tiles: [
                    {
                        id: 'square_8x8_7_1',
                        size: tiles_1.TILE_SIZES.SQUARE_8X8,
                        normalizedFrame: {
                            x: 0.5542907180385289,
                            y: 0.28633975481611207,
                            width: 0.07443082311733801,
                            height: 0.07443082311733801
                        }
                    },
                    {
                        id: 'square_8x8_7_2',
                        size: tiles_1.TILE_SIZES.SQUARE_8X8,
                        normalizedFrame: {
                            x: 0.37040280210157617,
                            y: 0.28633975481611207,
                            width: 0.07443082311733801,
                            height: 0.07443082311733801
                        }
                    },
                    {
                        id: 'square_8x8_7_3',
                        size: tiles_1.TILE_SIZES.SQUARE_8X8,
                        normalizedFrame: {
                            x: 0.46234676007005254,
                            y: 0.28633975481611207,
                            width: 0.07443082311733801,
                            height: 0.07443082311733801
                        }
                    },
                    {
                        id: 'square_8x8_7_4',
                        size: tiles_1.TILE_SIZES.SQUARE_8X8,
                        normalizedFrame: {
                            x: 0.5,
                            y: 0.37828371278458844,
                            width: 0.07443082311733801,
                            height: 0.07443082311733801
                        }
                    },
                    {
                        id: 'square_8x8_7_5',
                        size: tiles_1.TILE_SIZES.SQUARE_8X8,
                        normalizedFrame: {
                            x: 0.5919439579684763,
                            y: 0.37828371278458844,
                            width: 0.07443082311733801,
                            height: 0.07443082311733801
                        }
                    },
                    {
                        id: 'square_8x8_7_6',
                        size: tiles_1.TILE_SIZES.SQUARE_8X8,
                        normalizedFrame: {
                            x: 0.3161120840630473,
                            y: 0.37828371278458844,
                            width: 0.07443082311733801,
                            height: 0.07443082311733801
                        }
                    },
                    {
                        id: 'square_8x8_7_7',
                        size: tiles_1.TILE_SIZES.SQUARE_8X8,
                        normalizedFrame: {
                            x: 0.4080560420315236,
                            y: 0.37828371278458844,
                            width: 0.07443082311733801,
                            height: 0.07443082311733801
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.GREY_COUCH_BLANKET,
                tiles: [
                    {
                        id: 'square_12x12_7_1',
                        size: tiles_1.TILE_SIZES.SQUARE_12X12,
                        normalizedFrame: {
                            x: 0.5726795096322241,
                            y: 0.22066549912434325,
                            width: 0.11033274956217162,
                            height: 0.11033274956217162
                        }
                    },
                    {
                        id: 'square_12x12_7_2',
                        size: tiles_1.TILE_SIZES.SQUARE_12X12,
                        normalizedFrame: {
                            x: 0.3169877408056042,
                            y: 0.22066549912434325,
                            width: 0.11033274956217162,
                            height: 0.11033274956217162
                        }
                    },
                    {
                        id: 'square_12x12_7_3',
                        size: tiles_1.TILE_SIZES.SQUARE_12X12,
                        normalizedFrame: {
                            x: 0.4448336252189142,
                            y: 0.22066549912434325,
                            width: 0.11033274956217162,
                            height: 0.11033274956217162
                        }
                    },
                    {
                        id: 'square_12x12_7_4',
                        size: tiles_1.TILE_SIZES.SQUARE_12X12,
                        normalizedFrame: {
                            x: 0.5087565674255692,
                            y: 0.34851138353765326,
                            width: 0.11033274956217162,
                            height: 0.11033274956217162
                        }
                    },
                    {
                        id: 'square_12x12_7_5',
                        size: tiles_1.TILE_SIZES.SQUARE_12X12,
                        normalizedFrame: {
                            x: 0.6366024518388792,
                            y: 0.34851138353765326,
                            width: 0.11033274956217162,
                            height: 0.11033274956217162
                        }
                    },
                    {
                        id: 'square_12x12_7_6',
                        size: tiles_1.TILE_SIZES.SQUARE_12X12,
                        normalizedFrame: {
                            x: 0.2530647985989492,
                            y: 0.34851138353765326,
                            width: 0.11033274956217162,
                            height: 0.11033274956217162
                        }
                    },
                    {
                        id: 'square_12x12_7_7',
                        size: tiles_1.TILE_SIZES.SQUARE_12X12,
                        normalizedFrame: {
                            x: 0.3809106830122592,
                            y: 0.34851138353765326,
                            width: 0.11033274956217162,
                            height: 0.11033274956217162
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.GREY_COUCH_BLANKET,
                tiles: [
                    {
                        id: 'couch_7_1',
                        size: tiles_1.TILE_SIZES.SQUARE_20X20,
                        normalizedFrame: {
                            x: 0.3178633975481611,
                            y: 0.3239929947460595,
                            width: 0.1733800350262697,
                            height: 0.1733800350262697
                        }
                    },
                    {
                        id: 'couch_7_2',
                        size: tiles_1.TILE_SIZES.SQUARE_20X20,
                        normalizedFrame: {
                            x: 0.12697022767075306,
                            y: 0.3239929947460595,
                            width: 0.1733800350262697,
                            height: 0.1733800350262697
                        }
                    },
                    {
                        id: 'couch_7_3',
                        size: tiles_1.TILE_SIZES.SQUARE_20X20,
                        normalizedFrame: {
                            x: 0.5087565674255692,
                            y: 0.3239929947460595,
                            width: 0.1733800350262697,
                            height: 0.1733800350262697
                        }
                    },
                    {
                        id: 'couch_7_4',
                        size: tiles_1.TILE_SIZES.SQUARE_20X20,
                        normalizedFrame: {
                            x: 0.6996497373029772,
                            y: 0.3239929947460595,
                            width: 0.1733800350262697,
                            height: 0.1733800350262697
                        }
                    },
                    {
                        id: 'couch_7_5',
                        size: tiles_1.TILE_SIZES.SQUARE_20X20,
                        normalizedFrame: {
                            x: 0.4133099824868651,
                            y: 0.1330998248686515,
                            width: 0.1733800350262697,
                            height: 0.1733800350262697
                        }
                    },
                    {
                        id: 'couch_7_6',
                        size: tiles_1.TILE_SIZES.SQUARE_20X20,
                        normalizedFrame: {
                            x: 0.2224168126094571,
                            y: 0.1330998248686515,
                            width: 0.1733800350262697,
                            height: 0.1733800350262697
                        }
                    },
                    {
                        id: 'couch_7_7',
                        size: tiles_1.TILE_SIZES.SQUARE_20X20,
                        normalizedFrame: {
                            x: 0.6042031523642732,
                            y: 0.1330998248686515,
                            width: 0.1733800350262697,
                            height: 0.1733800350262697
                        }
                    }
                ]
            }
        ]
    }
];
exports.default = sevenLayouts;
//# sourceMappingURL=seven.js.map